import { View, KeyboardAvoidingView, Keyboard, TouchableOpacity, useWindowDimensions, VirtualizedList, ActivityIndicator, RefreshControl, DeviceEventEmitter, Pressable } from 'react-native'
import React, { useCallback, useEffect, useState } from 'react'
import { ThemeConsumer } from '@rneui/themed';
import { useFocusEffect } from '@react-navigation/native';
import Popover from 'react-native-popover-view';
import { shallowEqual } from 'react-redux';

import { config } from '../../../shared/environment';
import CommonDialogBox from '../../../shared/commonComponents/commonDialogBox';
import CommonService from '../../../shared/services/commonService';
import { CustomModal } from '../../../shared/commonComponents/customModal';

import { ZenBadge, ZenEmptyComponent, ZenFilterModal, ZenIcon, ZenLoader, ZenText, ZenToast } from 'zen-core-elements';
import { filterItemsProps } from 'zen-core-elements/src/elements/zenFilterModal/zenFilterType.modal';

import { useAppRoute } from '../../../types/@react-navigation/navigation';

import AddEditModifier from './addEditModifier';

import { deleteModifierOption, deleteModifierSet, getModifierOption, getModifierSet, ModifierOptionExist, modifierSetExist } from '../../../redux/slices/modifierSlice';
import { getScreenPermission, useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { ModifierOption, Modifierset, modifierPayload } from './modifierModule';
import { ListToolbar } from '../../../shared/commonComponents/listToolbar';
import { showApiError } from '../../../shared/utils/handleApiError';


const limit = 20
const Modifiers = () => {
	const { isWrite: isModifierWrite } = useAppSelector(getScreenPermission("ModifierScreen"), shallowEqual)
	const dispatch = useAppDispatch()
	const { width, height } = useWindowDimensions()
	const { params: { key } } = useAppRoute("Modifiers")
	const { loading } = useAppSelector((state) => state?.modifier?.modifiers)
	const option = useAppSelector((state) => state?.modifier?.modifiers.option, shallowEqual)
	const set = useAppSelector((state) => state?.modifier?.modifiers.set, shallowEqual)
	const [modifierData, setModifierData] = useState<(Modifierset | ModifierOption)[]>([])
	//variable used to handle searchBar 
	const [searchText, setSearchText] = useState<string | null>(null)
	//variable to store filter count
	const [filtercount, setFilterCount] = useState(0)
	//variable to store selected filter
	const [isVisibleFilter, setIsVisibleFilter] = useState(false)
	//Variable to maintain refresh control
	const [refresh, setRefresh] = useState<boolean>(false);
	//Variable to control footer loader
	const [footerLoader, setFooterLoader] = useState(false)
	//Variable to maintain confirmation popup state while removing a modifier
	const [isRemovePopover, setIsRemovePopover] = useState<boolean>(false)
	const currencySymbol = useAppSelector((state) => state?.common?.currentUser?.value?.purchasedCurrency?.currencySymbol) ?? '₹'

	const [selectedModifier, setSelectedModifier] = useState<number | ModifierOption>()
	//variable to store filter history data
	const [filterData, setFilterData] = useState<filterItemsProps[]>([
		{
			id: "1",
			filterName: "Medium",
			filterType: "radio",
			filterValue: [
				{
					value: 'POS',
					label: 'POS'
				},
				{
					value: 'WEB',
					label: 'WEB'
				}
			],
			initialSelected: ''
		}
	])
	const [transparentLoader, setTransparentLoader] = useState(false)

	const [payload, setPayload] = useState<modifierPayload["payload"] | undefined>()
	const [pageLoader, setPageLoader] = useState(true)
	const [editModal, setEditModal] = useState(false)

	useFocusEffect(
		useCallback(() => {
			if ((key == "options" && !option?.value?.length) ||
				(key == "set" && !set?.value?.length)) {
				if (!payload) {
					setPayload({
						filterData: null,
						limit: limit,
						offset: 0,
						searchText: null
					})
				}
			}
		}, [key, option, set, payload])
	);

	useEffect(() => {
		if (key == "options") {
			setModifierData(option?.value)
		}
		else {
			setModifierData(set?.value)
		}
		setPageLoader(false)
	}, [option?.value, set?.value])

	useEffect(() => {
		if (payload) {
			getModifiers()
		}
	}, [payload])

	// useEffect to trigger filterzone whenever text is searched
	useEffect(() => {
		if (searchText != null) {
			const searchDebounceFunction = setTimeout(() => {
				setPageLoader(true)
				setPayload((prev) => ({
					...prev!!,
					searchText: searchText,
					offset: 0
				}))
			}, 1000)
			return () => clearTimeout(searchDebounceFunction)
		}
	}, [searchText]);

	const getModifiers = () => {
		let payloadParams: modifierPayload = {
			storeId: config?.storeId,
			payload: payload!
		};
		(key == "options" ?
			dispatch(getModifierOption(payloadParams)) :
			dispatch(getModifierSet(payloadParams))
		).unwrap().catch(showApiError).finally(() => {
			setPageLoader(false)
			setRefresh(false)
			setFooterLoader(false)
		})
	}

	const getItem = (item: any[], index: number) => {
		let array: any = [];
		let numOfColumns = width > height ? 2 : 1
		for (let i = 0; i < numOfColumns; i++) {
			let temp = item?.[index * numOfColumns + i];
			temp && array?.push(temp);
		}
		return array;
	};

	const renderItem = ({ item, index }: { item: (Modifierset & ModifierOption)[], index: number }) => {
		return (
			<ThemeConsumer>
				{({ theme }) => (
					<View key={index} style={{ flexDirection: "row" }}>
						{item?.map((modifier, ResponseDataIndex: number) => (
							<View key={ResponseDataIndex} style={{ flex: 1 / (width > height ? 2 : 1) }}>
								<View style={{
									marginBottom: 10,
									marginHorizontal: 10,
									padding: 10,
									borderRadius: 5,
									backgroundColor: theme.light
								}}>
									<View style={{ flexDirection: "row", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
										<View style={{ width: "70%", gap: 5 }}>
											{modifier?.modifierName ?
												<View style={{ gap: 5, flexDirection: "row", alignItems: "flex-start" }}>
													<ZenText content={"Set Name:"} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
													<ZenText content={modifier?.modifierName} size={theme?.smallFontSize} style={{ fontFamily: theme?.bold, color: theme?.lightDark, top: -2 }} />
												</View>
												: <></>}
											{modifier?.optionValue ?
												<View style={{ gap: 5, flexDirection: "row", alignItems: "center" }}>
													<ZenText content={"Option Name:"} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
													<ZenText content={modifier?.optionValue} size={theme?.smallerFontSize} style={{ fontFamily: theme?.bold, color: theme?.lightDark, top: -2 }} />
												</View>
												: <></>}
											{modifier?.alternateName !== undefined ?
												<View style={{ gap: 5, flexDirection: "row", alignItems: "center" }}>
													<ZenText content={"Alt Name:"} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
													<ZenText content={modifier?.alternateName || "---"} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
												</View>
												: <></>}
											{modifier?.price ?
												<View style={{ gap: 5, flexDirection: "row", alignItems: "center" }}>
													<ZenText content={"Price:"} size={theme?.errorFontSize} style={{ fontFamily: theme?.medium, color: theme?.grey }} />
													<ZenText content={CommonService?.currencyStandard(currencySymbol, modifier?.price?.toString())} size={theme?.smallHeaderFontSize} style={{ fontFamily: theme?.bold, color: theme?.lightDark }} />
												</View>
												: <></>}
											<View style={{ gap: 5, flexDirection: "row", alignItems: "center" }}>
												<ZenBadge
													badgeName={modifier?.medium}
													badgeColor={modifier?.medium == "POS" ? theme?.customerStatus?.wholesaleStatus : theme?.customerStatus?.typeWholesalecolor}
													badgeTextColor={theme?.light}
													badgeTextSize={"small"}
													badgeTextStyle={{ fontFamily: theme?.bold, padding: 2 }}
												/>
											</View>
										</View>
										<View style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
											<TouchableOpacity onPress={() => {
												setSelectedModifier(key == "set" ? modifier?.id : modifier)
												setEditModal(true)
											}}>
												<ZenIcon
													name='pencil'
													type='octicon'
													color={theme?.iconColor}
													size={theme?.iconSize}
													style={{
														"padding": 10,
														"backgroundColor": theme.lightBackgroundColor,
														"borderRadius": 10
													}}
												/>
											</TouchableOpacity>
											{isModifierWrite && <TouchableOpacity onPress={() => {
												setSelectedModifier(modifier?.id)
												setIsRemovePopover(true)
											}}>
												<ZenIcon
													name='delete-outline'
													type='material-community'
													color={theme?.red}
													size={theme?.iconSize}
													style={{
														"padding": 10,
														"backgroundColor": theme.lightBackgroundColor,
														"borderRadius": 10
													}}
												/>
											</TouchableOpacity>}
										</View>
									</View>
								</View>
							</View>
						))}
					</View>
				)
				}
			</ThemeConsumer >
		)
	}


	const footerComponent = () => {
		return (
			<ThemeConsumer>
				{({ theme }) => (
					footerLoader ?
						<View>
							<ActivityIndicator size={"small"} color={theme?.primary} />
						</View >
						: undefined
				)}
			</ThemeConsumer>
		)
	}

	const onRefresh = () => {
		setRefresh(true)
		setSearchText(null)
		DeviceEventEmitter?.emit(key == "options" ? "modifierOption" : "modifierSet")
		setPayload({
			offset: 0,
			limit,
			filterData: null,
			searchText: null
		})
	}
	const onEndReached = () => {
		let offsetValue = payload?.offset || 0
		const count = key == "options" ? option?.count : set?.count
		if (!footerLoader && (count > offsetValue)) {
			setFooterLoader(true)
			setPayload((prev) => ({
				...prev!!,
				offset: offsetValue + limit
			}))
		}
	}

	const deleteModifiers = () => {
		if (typeof selectedModifier == "number") {
			(key == "options" ?
				dispatch(deleteModifierOption({ modifierId: selectedModifier!!, storeId: config?.storeId })) :
				dispatch(deleteModifierSet({ modifierId: selectedModifier!!, storeId: config?.storeId }))
			).unwrap().then((response) => {
				if (response?.success) {
					ZenToast({
						type: "success",
						message: "Modifier deleted successfully"
					})
					setPayload((prev) => ({
						...prev!!,
						offset: 0
					}))
				}
			}).catch(() => {
				ZenToast({
					type: "error",
					message: "Failed to delete the modifier"
				})
			}).finally(() => {
				setTransparentLoader(false)
				setSelectedModifier(undefined)
			})
		}
	}

	const checkModifierExist = () => {
		if (typeof selectedModifier == "number") {
			(key == "options" ?
				dispatch(ModifierOptionExist({ id: selectedModifier!!, storeId: config?.storeId })) :
				dispatch(modifierSetExist({ id: selectedModifier!!, storeId: config?.storeId }))
			).unwrap().then((response) => {
				if (response?.result == null) {
					deleteModifiers()
				} else {
					ZenToast({
						type: "warning",
						message: key == "options" ? "This modifier cannot be removed because it is already used in some modifier sets" :
							"You can't remove this modifier set,since it is associated with products!"
					})
					setTransparentLoader(false)
				}
			}).catch(() => {
				ZenToast({
					type: "error",
					message: "Failed to delete the modifier"
				})
				setTransparentLoader(false)
			})
		}
	}

	const deleteConfirmation = (value: { id: number }) => {
		setIsRemovePopover(false)
		if (value?.id == 2) {
			setTransparentLoader(true)
			checkModifierExist()
		}
	}
	return (
		<ThemeConsumer>
			{({ theme }) => (
				<KeyboardAvoidingView onStartShouldSetResponder={() => { Keyboard?.dismiss(); return false }} style={{ flex: 1, backgroundColor: "#f8f8f8", paddingBottom: 10 }}>
					<View style={{ gap: 10, flex: 1, paddingTop: 10 }}>
						<ListToolbar
							search={{
								value: searchText ?? "",
								onChange: (val) => setSearchText(val as string),
								onCancel: () => setSearchText(null),
								placeholder: 'Search by Name',
							}}
							filter={{
								count: filtercount ?? 0,
								onPress: () => setIsVisibleFilter(true),
							}}
							buttons={isModifierWrite ? [{
								onPress: () => {
									setSelectedModifier(undefined)
									setEditModal(true)
								},
								title: `Add ${key}`,
								variant: "primary"
							}] : []}
						/>
						{(loading && !refresh && !footerLoader && pageLoader) ?
							<ZenLoader lottie={require('../../../assets/infinityLoader.json')} lottieType='Local' viewStyle={{ backgroundColor: "transparent" }} /> :
							<View style={{ flex: 1 }}>
								<VirtualizedList
									keyExtractor={(_: any, index: number) => index?.toString()}
									getItemCount={(data: any) => data?.length}
									getItem={getItem}
									scrollEnabled={true}
									nestedScrollEnabled={true}
									renderItem={renderItem}
									data={modifierData || []}
									keyboardDismissMode="on-drag"
									showsVerticalScrollIndicator={false}
									onEndReachedThreshold={0.01}
									contentContainerStyle={[{ paddingBottom: modifierData.length ? 10 : undefined, flex: modifierData?.length ? undefined : 1 }]}
									ListFooterComponent={footerComponent}
									ListFooterComponentStyle={{ height: modifierData.length ? 70 : 0 }}
									ListEmptyComponent={<ZenEmptyComponent viewStyle={{ backgroundColor: theme?.light }} />}
									onEndReached={onEndReached}
									refreshControl={<RefreshControl refreshing={refresh} onRefresh={onRefresh} />}
								/>
							</View>
						}
					</View>
					{
						width < height && isModifierWrite &&
						<Pressable
							style={theme?.staffListStyle?.fabButton}
							onPress={() => {
								setSelectedModifier(undefined)
								setEditModal(true)
							}}>
							<ZenIcon type="material-community" name={"plus"} size={25} color={theme?.light} />
						</Pressable>
					}
					<ZenFilterModal
						filterName={key == "options" ? "modifierOption" : "modifierSet"}
						setVisible={setIsVisibleFilter}
						visible={isVisibleFilter}
						filterItems={filterData}
						setFilterItems={setFilterData}
						filterCount={filtercount}
						setFilterCount={setFilterCount}
						title="Modifier Filter"
						isSingleExpand={false}
						onConfirm={(val) => {
							let data: { medium?: string } = {}
							if (val?.values?.Medium) {
								data.medium = val?.values?.Medium
							}
							setPageLoader(true)
							setPayload((prev) => ({
								...prev!!,
								offset: 0,
								filterData: Object?.keys(data)?.length ? JSON.stringify(data) : null
							}))
						}
						}
					/>
					<Popover isVisible={isRemovePopover} popoverStyle={{ width: width > height ? 400 : 300, borderRadius: 10 }}>
						<CommonDialogBox type='DELETE' replaceValue={'modifier ' + (key == "options" ? "option" : "set")} confirmation={deleteConfirmation} />
					</Popover>

					<AddEditModifier
						modalVisible={editModal}
						page={key}
						payload={selectedModifier}
						setModalVisible={setEditModal}
						setPayload={setPayload}
					/>

					<CustomModal transparent visible={transparentLoader}>
						<ZenLoader viewStyle={{ backgroundColor: "transparent" }} color={theme?.primary} lottieType="Local" lottie={require('../../../assets/infinityLoader.json')} />
					</CustomModal>

				</KeyboardAvoidingView >
			)}
		</ThemeConsumer>
	)
}

export default Modifiers